import { CalendarDays, ChevronDown } from 'lucide-react';
import SignUpSlot from '../components/SignUpSlot';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import SignUpDate from '../components/SignUpDate';
import s from '../styles/modules/SignUp.module.scss';
import { cn } from '../lib/utils';
import BreadcrumbComponent from '../components/BreadcrumbComponent';
import { useSignUp } from '../hooks/useSignUp';

const SignUp = () => {
  const {
    selectedClubValue,
    openAccordion,
    slots,
    slotDays,
    listOfTrainers,
    setOpenAccordion,
    formatDate,
    formatDayOfWeek,
    setSelectedClubValue,
    setIdClub,
    clubsArr,
  } = useSignUp();

  return (
    <div className={s.wrapper_sign_up}>
      <div className="rounded-lg bg-white p-3">
        <BreadcrumbComponent link={'Расписание'} />
        <div className="mb-6 flex items-center gap-2">
          <CalendarDays className="h-5 w-5 text-primary" />
          <h2 className="text-xl font-medium text-gray-900">Расписание</h2>
        </div>

        <div className="mb-6 flex items-center gap-4">
          <span className="text-sm font-medium text-gray-700">Филиал:</span>
          <Select
            value={selectedClubValue}
            onValueChange={(value) => {
              const clubs = clubsArr;
              const selectedClub: any = clubs.find((club: any) => club.title === value);
              if (selectedClub) {
                localStorage.setItem('club_name', value);
                localStorage.setItem('id_club', selectedClub.id);
                setIdClub(selectedClub.id);
                setSelectedClubValue(value);
                setOpenAccordion('');
              }
            }}>
            <SelectTrigger className="w-[200px]">
              <SelectValue placeholder="Выберите филиал" />
            </SelectTrigger>
            <SelectContent>
              {localStorage.getItem('phone') === '+79645338082'
                ? clubsArr.map(({ title }, i) => (
                    <SelectItem key={i} value={title}>
                      {title}
                    </SelectItem>
                  ))
                : clubsArr
                    .filter((club) => club.id !== '246e5cc0-ae65-11ef-9106-2a618cb265e1')
                    .map(({ title }, i) => (
                      <SelectItem key={i} value={title}>
                        {title}
                      </SelectItem>
                    ))}
            </SelectContent>
          </Select>
        </div>
        {
          <div className="space-y-3">
            {slotDays.length > 0 ? (
              slotDays.map((date, index) => (
                <Accordion
                  type="single"
                  collapsible
                  key={index}
                  value={openAccordion}
                  onValueChange={setOpenAccordion}>
                  <AccordionItem
                    value={date}
                    className="group w-full overflow-hidden rounded-lg border bg-white relative">
                    <AccordionTrigger
                      className={cn(
                        'w-full px-4 py-3 transition-all duration-200 hover:no-underline sm:px-6 sm:py-4',
                        'data-[state=open]:bg-primary/5',
                        '[&[data-state=open]>div]:text-primary [&[data-state=open]_.icon]:text-primary',
                        '[&[data-state=open]_.chevron]:rotate-180',
                        'group hover:bg-gray-50/80',
                        'bg-[#f9fafb] [&>svg]:hidden',
                      )}>
                      <div
                        className={`flex w-full items-center gap-2 transition-colors duration-200 sm:gap-3 ${s.date_of_sign_up} `}>
                        <div className="flex items-center gap-2">
                          <div className="rounded-full bg-primary/10 p-2 sm:p-2">
                            <CalendarDays className="icon h-5 w-5 transition-colors duration-200" />
                          </div>
                          <div className="flex min-w-[92px] flex-col items-start">
                            <span className="font-medium">{formatDate(date)}</span>
                            <span className="text-sm capitalize text-gray-500">
                              {formatDayOfWeek(date)}
                            </span>
                          </div>
                        </div>
                        <div className="flex items-center">
                          <SignUpDate date={date} trainers={listOfTrainers} slots={slots} />
                        </div>
                        <div className="ml-auto flex items-center gap-2">
                          <span
                            className={`text-sm text-gray-500 transition-colors duration-200 group-hover:text-gray-900 ${s.text_show_more_title}`}>
                            Показать занятия
                          </span>
                          <div
                            className={`rounded-full bg-gray-50 p-2 transition-colors duration-200 group-hover:bg-gray-100 ${s.icon_show_more_title}`}>
                            <ChevronDown className="chevron ease-[cubic-bezier(0.87,_0,_0.13,_1)] h-4 w-4 text-gray-500 transition-all duration-300 group-hover:text-gray-900" />
                          </div>
                        </div>
                      </div>
                    </AccordionTrigger>
                    <AccordionContent className="data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
                      <div className="px-6 pb-4 pt-2">
                        <div className="space-y-3 border-t pt-4">
                          {slots
                            .filter((slot) => slot.date_time.startsWith(date))
                            .map((slot, index) => (
                              <SignUpSlot
                                key={index}
                                trainers={listOfTrainers}
                                slot={slot}
                                onSuccessfulSignUp={() => setOpenAccordion('')}
                              />
                            ))}
                        </div>
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              ))
            ) : (
              <div className="px-4 py-8 text-center">
                <CalendarDays className="mx-auto mb-4 h-12 w-12 text-gray-400" />
                <h3 className="mb-1 text-lg font-medium text-gray-900">Нет доступных занятий</h3>
                <p className="text-sm text-gray-500">
                  Пожалуйста, выберите другой филиал или попробуйте позже
                </p>
              </div>
            )}
          </div>
        }
      </div>
    </div>
  );
};

export default SignUp;
